import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { moment } from "ngx-bootstrap/chronos/test/chain";
import { Observable } from "rxjs/Observable";

import { CommonService } from "../../../../../client/views/services/common.service";
import { AppService } from "../../../../views/services/app.service";
import { User } from "../../../../views/services/user.model";
import { InternalReviewData } from "../../../../views/shared/models/review-data";
import { InternalLoggerService } from "../../accmgr/services/internal-audit-logger.service";
import { InternalTestService } from "../../accmgr/services/internaltest.service";
import { PersonRequestService } from "../../accmgr/services/person-request-service";
import { AssignTestService } from "../service/assign-test.service";

@Component({
  templateUrl: "./assign-test-administration.component.html",
  styleUrls: ["./assign-test-administration.component.css"]
})
export class AssignTestAdminComponent implements OnInit, OnDestroy {
  public personId: string;
  public assignTestForm: FormGroup;
  public studentDetails: any;
  public certification: string;
  public tests: any;
  public testDates: any;
  public savedTestDateIds = [];
  public optedTestDates = "";
  public assignTestFormSubmitVal: boolean = false;
  public testDateAlreadyExists = false;
  internalReviewData: InternalReviewData = {};
  public selectedTestId: any;
  public selectedTestDateId: any;
  public testDateIDs = [];
  public confirmationModalMessage = "";
  public assignTA: string;
  public optedTestDateName: string = "";
  public selectedTestDateName: string = "";
  public selectedTestType: string;
  public userProfile: User;
  public certificationList = [];
  public personTestList: any;
  public errorMsg: boolean = false;
  public testName: any;
  public reviewToDate: any;
  public adminId: string;
  public dob: any;
  public hsCode: any;
  public sourceSystem: any;
  public taaPin: string;
  public actId: string;
  public requestId: string;
  public requestStatusCode: string;
  public selectedOrg: any;
  public users: any;
  public user: any;
  public selectedList = [];
  public lastNm: String;
  public firstNm: String;
  public orgMdmId: string;

  constructor(
    private personRequestService: PersonRequestService,
    private assignTestService: AssignTestService,
    private commonService: CommonService,
    private internalTestService: InternalTestService,
    private router: Router,
    private appService: AppService,
    private internalLoggerService: InternalLoggerService
  ) {}
  ngOnInit() {
    this.appService.getUserProfile().then(user => (this.userProfile = user));
    this.selectedOrg = this.personRequestService.getOrg();
    Observable.forkJoin(
      this.commonService.getDynContent("SPECIAL_TESTING_CERTIFICATION_TWO"),
      this.commonService.getDynContent("ASSIGN_TEST_ADMIN"),
      this.internalTestService.getTest()
    ).subscribe(([certification, assignTA, resp]) => {
      this.certification = certification;
      this.tests = resp;
      this.assignTA = assignTA;
    });
    if (sessionStorage.getItem("internalStudentDetails")) {
      const studentDetails: any = JSON.parse(
        sessionStorage.getItem("internalStudentDetails")
      );
      this.personId = studentDetails.personId;
      this.requestId = studentDetails.requestId;
    }
    this.buildCertificationList();
    this.buildTest();

    this.assignTestForm = new FormGroup({
      lastName: new FormControl(),
      firstName: new FormControl(),
      test: new FormControl("", Validators.required),
      taName: new FormControl("", Validators.required)
    });
  }
  ngOnDestroy() {}

  buildTest() {
    Observable.forkJoin([
      this.personRequestService.getPersonById(this.personId),
      this.personRequestService.getPersonNameById(this.personId),
      this.personRequestService.getPersonTestById(this.personId),
      this.personRequestService.getPersonRequestForDisplay(this.requestId)
    ]).subscribe(([person, personName, personTest, request]) => {
      this.dob = person[0].BIRTH_DT;
      if (this.dob) {
        this.dob = moment(this.dob).format("MM-DD-YYYY");
      }
      this.actId = person[0].ACT_ID ? person[0].ACT_ID : "";
      this.internalReviewData.taaPin = person[0].ACCOMMS_PIN;
      this.internalReviewData.firstNm = personName[0].FIRST_NM;
      this.internalReviewData.middleNm = personName[0].MIDDLE_NM
        ? personName[0].MIDDLE_NM
        : "";
      this.internalReviewData.lastNm = personName[0].LAST_NM;
      this.hsCode = request[0].HS_CODE ? request[0].HS_CODE : "";
      this.orgMdmId = request[0].ORG_MDM_ID ? request[0].ORG_MDM_ID : "";
      this.sourceSystem = request[0].SOURCE_SYSTEM
        ? request[0].SOURCE_SYSTEM
        : "";
      this.studentDetails = {
        personId: this.personId,
        taaPin: this.internalReviewData.taaPin,
        personName: this.internalReviewData.personName
      };
      this.personRequestService
        .getRequestStatusCodeById(request[0].REQUEST_STATUS_CODE_ID)
        .subscribe(status => {
          this.requestStatusCode = status[0] ? status[0].STATUS_CD : "";
        });
      this.getSavedTestDates(personTest);
    });
  }
  buildCertificationList() {
    this.certificationList = [];
    this.assignTestService.getPersonTestList(this.personId).subscribe(data => {
      this.personTestList = data;
      if (this.personTestList.body.length > 0) {
        let value: any = {};
        for (let i = 0; i < this.personTestList.body.length; i++) {
          Promise.all([
            new Promise((resolve, reject) => {
              Observable.forkJoin(
                this.assignTestService.getTestDetails(
                  this.personTestList.body[i].TEST_DATE_ID
                )
              ).subscribe(
                ([res]) => {
                  resolve(res);
                },
                err => {
                  reject(err);
                }
              );
            })
          ]).then(([res]) => {
            value = {};
            const ans: any = res;
            value.PERSON_TEST_ID = this.personTestList.body[i].PERSON_TEST_ID;
            value.CERTIFIED_FL = this.personTestList.body[i].CERTIFIED_FL;
            value.CERTIFIED_BY_DS = this.personTestList.body[i].CERTIFIED_BY_DS;
            value.SPL_TEST_ADMIN_END_DT = this.extractFormattedDate(
              ans.body[0].SPL_TEST_ADMIN_END_DT
            );
            value.SPL_TEST_ADMIN_START_DT = this.extractFormattedDate(
              ans.body[0].SPL_TEST_ADMIN_START_DT
            );
            value.TEST_DATE_NM = ans.body[0].TEST_DATE_NM;
            if (moment().isAfter(moment(ans.body[0].CERTIFY_CUT_OFF_DT))) {
              //past
              value.Certification_Deadline = "Deadline is passed";
              if (value.CERTIFIED_FL === "Y") {
                value.checked = true;
              } else {
                value.checked = false;
              }
            } else if (
              moment().isBefore(moment(ans.body[0].CERTIFY_CUT_OFF_DT))
            ) {
              //future
              value.Certification_Deadline = this.extractFormattedDate(
                ans.body[0].CERTIFY_CUT_OFF_DT
              );
              if (value.CERTIFIED_FL === "Y") {
                value.checked = true;
              } else {
                value.checked = false;
              }
            }

            this.certificationList.push(value);
          });
        }
      }
    });
  }
  extractFormattedDate(isoFormattedDate) {
    //This function is to extract only date irrespective of timezone format
    let formattedDate = "";
    formattedDate += moment.utc(isoFormattedDate).format("MMMM") + " ";
    formattedDate += moment.utc(isoFormattedDate).get("date") + ", ";
    formattedDate += moment.utc(isoFormattedDate).get("year");
    return formattedDate;
  }

  changeTest(event) {
    const test = this.assignTestForm.controls["test"].value
      ? this.assignTestForm.controls["test"].value.TEST_ID
      : false;
    this.testName = this.assignTestForm.controls["test"].value
      ? this.assignTestForm.controls["test"].value.TEST_NM
      : "";
    this.testDates = [];
    if (test) {
      this.internalTestService
        .getDates(test)
        .map((res: any) => {
          return res.body;
        })
        .subscribe(testDates => {
          this.testDates = testDates;
        });
    }
  }

  addSelectedTest(data) {
    this.user = !this.user;
    if (this.selectedOrg["ORG_MDM_ID"]) {
      Observable.forkJoin([
        this.personRequestService.getTestCoordinator(
          this.selectedOrg["ORG_MDM_ID"]
        )
      ]).subscribe(([response]) => {
        let usersList: any;
        this.users = [];
        usersList = response.body;
        usersList.names.forEach(element => {
          this.users.push(element);
        });
      });
    } else {
      Observable.forkJoin([
        this.personRequestService.getOrgMdmId(
          this.selectedOrg["ORGANIZATION_ID"]
        )
      ]).subscribe(([id]) => {
        Observable.forkJoin([
          this.personRequestService.getTestCoordinator(
            id.body[0]["ENTITY_ID"].trim()
          )
        ]).subscribe(([response]) => {
          let usersList: any;
          this.users = [];
          usersList = response.body;
          usersList.names.forEach(element => {
            this.users.push(element);
          });
        });
      });
    }
    this.selectedList = [];
    this.selectedList.push(data);
  }

  cancelnavigate() {
    this.router.navigate(["exAccreqdetails"]);
  }

  assignTestFormSubmit(formVal) {
    this.assignTestFormSubmitVal = true;
    if (
      (formVal.value.test !== "" || formVal.value.taName !== "") &&
      formVal.valid
    ) {
      const check: boolean = false;

      for (let i = 0; i < this.savedTestDateIds.length; i++) {
        if (this.savedTestDateIds[i] === formVal.value.taName.TEST_DATE_ID) {
          this.testDateAlreadyExists = true;
          break;
        } else if (i === this.savedTestDateIds.length - 1) {
          this.testDateAlreadyExists = false;
          this.selectedTestDateId = formVal.value.taName.TEST_DATE_ID;
          this.onOpenHandled("confirmationModal", "testDateId");
        }
      }
      if (this.savedTestDateIds.length === 0) {
        this.testDateAlreadyExists = false;
        this.selectedTestDateId = formVal.value.taName.TEST_DATE_ID;
        this.onOpenHandled("confirmationModal", "testDateId");
      }
    }
  }
  getSavedTestDates(data) {
    const array = [];
    data.forEach(element => {
      this.savedTestDateIds.push(element.TEST_DATE_ID);
      array.push(
        new Promise((resolve, reject) => {
          Observable.forkJoin(
            this.internalTestService.getTestDateNameById(element.TEST_DATE_ID)
          ).subscribe(
            ([dates]) => {
              resolve(dates.body[0]);
            },
            err => {
              reject(err);
            }
          );
        })
      );
    });
    Promise.all(array).then(value => {
      this.testType(value);
    });
  }

  testType(data) {
    const array = [];
    data.forEach(element => {
      this.testDateIDs.push(element.TEST_ID);
      array.push(
        new Promise((resolve, reject) => {
          Observable.forkJoin(
            this.internalTestService.getTestNameById(element.TEST_ID)
          ).subscribe(
            ([dates]) => {
              resolve(dates.body[0]);
            },
            err => {
              reject(err);
            }
          );
        })
      );
    });
    Promise.all(array).then(value => {
      value.forEach((element, index) => {
        this.optedTestDates =
          this.optedTestDates +
          element.TEST_NM +
          "-" +
          data[index].TEST_DATE_NM +
          (index !== value.length - 1 ? ", " : "");
      });
    });
  }
  onOpenHandled(id, prm) {
    this.confirmationModalMessage = `By clicking ok below, I certify that if the examinee is approved to test through the Special Testing 
    program during a National test window, I personally meet all of the requirements for the Special Testing coordinator as specified in 
    the ACT Policies for ACT Special Testing and that I, or a designated qualified member of my staff as specified in the ACT Policies for 
    ACT Special Testing, agree to administer tests in accordance to the policies and guidelines stated in the ACT Special Testing Administration 
    Manual included with the test materials shipment. I will ensure to maintain security and confidentiality of all testing materials; materials 
    will only be used for the examinee identified in this request and all materials will be returned to ACT within 24 hours upon completion of 
    the test administration. I understand that by agreeing to be a Special Testing coordinator, I consent to the ACT Privacy Policy 
    (http://www.act.org/content/act/en/privacypolicy.html), which is incorporated into these Policies for ACT Special Testing by reference, 
    including consent to the collection of my personally identifying information and its subsequent use and disclosure.`;
    document.getElementById(id).style.display = "block";
  }

  onCloseHandled(id) {
    document.getElementById(id).style.display = "";
  }

  onUpdateHandled() {
    this.addingTest();
  }

  saveUser() {
    //if (this.user) {
    const body = {
      userName: this.user,
      person_test_id: this.selectedList[0].PERSON_TEST_ID,
      checked: this.selectedList[0].checked
    };
    if (this.user) {
      this.users.forEach(eachUser => {
        if (eachUser.firstName + " " + eachUser.lastName === this.user) {
          body["userId"] = eachUser.uid;
        }
      });
    }
    this.personRequestService.saveUserDetails(body).subscribe(
      data => {
        this.buildCertificationList();
      },
      err => {
        console.log(err);
      }
    );
    // }
  }

  addingTest() {
    this.optedTestDateName = "";
    this.selectedTestDateName = "";
    this.testDates.forEach(element => {
      if (element.TEST_DATE_ID === this.selectedTestDateId) {
        this.optedTestDateName = element.TEST_DATE_NM;
        this.selectedTestDateName = this.testName + "-" + element.TEST_DATE_NM;
      }
    });

    this.testDateAlreadyExists = false;
    const personTest = {
      PERSON_ID: this.personId,
      TEST_DATE_ID: this.selectedTestDateId,
      CREATED_BY_DS: this.userProfile.loggedInUser,
      UPDATED_BY_DS: this.userProfile.loggedInUser
    };
    const data = {
      firstName: this.internalReviewData.firstNm,
      lastName: this.internalReviewData.lastNm,
      TAA_PIN: this.internalReviewData.taaPin,
      mode: "PBT"
    };
    const loggerModel = {
      MODULE_ID: "REVIEW",
      CATEGORY_ID: "ASSIGN_TEST_AMINISTRATION",
      COMPONENT_ID: "ASSIGN_TEST_AMINISTRATION",
      CREATED_BY_DS: this.userProfile.loggedInUser,
      MESSAGE_TX: "Associated an examinee to a new test administration.",
      REFERENCE_ID: this.personId,
      SEVERITY_VAL: "",
      UPDATED_BY_DS: this.userProfile.loggedInUser,
      USER_DATA_VAL:
        "Examinee " +
        this.internalReviewData.firstNm +
        " " +
        this.internalReviewData.lastNm +
        " is associated with test administration " +
        this.selectedTestDateName
    };

    Observable.forkJoin(
      this.internalTestService.getTestDateNameById(this.selectedTestDateId)
    ).subscribe(([testType]) => {
      if (testType) {
        const data1: any = testType;
        this.selectedTestType = data1.body[0].TEST_DATE_TYPE;
        this.reviewToDate = data1.body[0].REVIEW_TO_DT;
        this.adminId = data1.body[0].ADMIN_ID;
      }
      if (this.selectedTestType === "State") {
        personTest["PERSON_TEST_TYPE"] = "State";
        this.internalTestService
          .postPersonTest(personTest)
          .subscribe(response => {
            this.buildCertificationList();
          });
        this.savedTestDateIds.push(this.selectedTestDateId);
        this.optedTestDates = this.optedTestDates
          ? this.optedTestDates + ", " + this.selectedTestDateName
          : this.selectedTestDateName;
        this.selectedTestId = "";
        this.selectedTestDateId = "";
        this.assignTestForm.reset();
        this.assignTestFormSubmitVal = false;
        this.testName = "";
        this.internalLoggerService
          .updateAuditLogger(loggerModel)
          .subscribe(success => {}, err => {});
      } else {
        Observable.forkJoin(
          this.internalTestService.postTestType(data),
          this.personRequestService.getPersonAddressById(this.personId)
        ).subscribe(([result, personAddress]) => {
          if (result.status === 200) {
            const addressDetails: any = personAddress;
            this.savedTestDateIds.push(this.selectedTestDateId);
            this.optedTestDates = this.optedTestDates
              ? this.optedTestDates + ", " + this.selectedTestDateName
              : this.selectedTestDateName;
            this.selectedTestId = "";
            this.selectedTestDateId = "";
            this.assignTestForm.reset();
            this.assignTestFormSubmitVal = false;
            this.testName = "";
            if (result.body["Test Type"] === "Special") {
              personTest["PERSON_TEST_TYPE"] = result.body["Test Type"];
              personTest["CERTIFIED_FL"] = "N";
            } else {
              personTest["PERSON_TEST_TYPE"] = "National";
            }
            Observable.forkJoin(
              this.internalTestService.postPersonTest(personTest),
              this.personRequestService.getSourceFlag()
            ).subscribe(([response, sourceFlag]) => {
              if (response.status === 200) {
                if (sourceFlag.body["sourceFlag"]) {
                  console.log("Pre source:" + this.sourceSystem);
                  this.sourceSystem = "MyACT";
                  console.log("post source:" + this.sourceSystem);
                }
                this.internalLoggerService
                  .updateAuditLogger(loggerModel)
                  .subscribe(success => {}, err => {});
                const currentdate: any = new Date();

                let details: any = {};

                if (this.sourceSystem === "MyACT") {
                  details = {
                    sourceSystem: this.sourceSystem,
                    status: this.requestStatusCode,
                    registration_id: "",
                    test_date: this.optedTestDateName,
                    adminId: this.adminId,
                    extAdminId: "",
                    request_status: "",
                    taa_pin: this.internalReviewData.taaPin,
                    lName: this.internalReviewData.lastNm,
                    fName: this.internalReviewData.firstNm,
                    dob: this.dob,
                    actId: this.actId ? this.actId : "",
                    hsCode: this.hsCode,
                    orgMdmId: this.orgMdmId,
                    event: "accommodations.created"
                  };
                } else {
                  details = {
                    sourceSystem: this.sourceSystem,
                    actId: this.actId,
                    zip: addressDetails[0].ZIP_POSTAL_CD,
                    extAdminId: "",
                    status: "",
                    dob: this.dob,
                    hsCode: this.hsCode,
                    state: addressDetails[0].STATE_CD,
                    lName: this.internalReviewData.lastNm,
                    taaPin: this.internalReviewData.taaPin,
                    fName: this.internalReviewData.firstNm,
                    city: addressDetails[0].CITY_NM,
                    adminId: this.adminId,
                    address: addressDetails[0].STREET_1_AD
                      ? addressDetails[0].STREET_1_AD
                      : "" + " " + addressDetails[0].STREET_2_AD
                      ? addressDetails[0].STREET_2_AD
                      : "",
                    countryCd: addressDetails[0].COUNTRY_CD,
                    mName: this.internalReviewData.middleNm,
                    regId: "",
                    orderId: ""
                  };
                }

                if (this.reviewToDate) {
                  if (
                    (this.selectedTestType === "National" ||
                      this.selectedTestType === "Special") &&
                    Date.parse(this.reviewToDate) >= Date.parse(currentdate)
                  ) {
                    if (
                      this.requestStatusCode === "Approved" ||
                      this.requestStatusCode === "PartiallyApproved"
                    ) {
                      Observable.forkJoin(
                        this.personRequestService.postAccomsType(data)
                      ).subscribe(([accommsType]) => {
                        const accommStatus: any = accommsType.body;
                        if (this.sourceSystem === "MyACT") {
                          details.request_status =
                            accommStatus.data.accomm_type;
                        } else {
                          details.status = accommStatus.data.accomm_type;
                        }

                        this.personRequestService
                          .postRabbitMq(details)
                          .subscribe(temp => {
                            const rabbitMq: any = temp;
                            if (
                              rabbitMq.status === 200 &&
                              rabbitMq.body.status ===
                                "Added sucessfully to RabbitMq"
                            ) {
                              console.log(
                                "Added sucessfully to RabbitMq with type " +
                                  accommStatus.data.accomm_type
                              );
                            }
                          });
                      });
                    } else {
                      this.personRequestService
                        .postRabbitMq(details)
                        .subscribe(temp => {
                          const rabbitMq: any = temp;
                          if (
                            rabbitMq.status === 200 &&
                            rabbitMq.body.status ===
                              "Added sucessfully to RabbitMq"
                          ) {
                            console.log(
                              "NotApproved Added sucessfully to RabbitMq"
                            );
                          }
                        });
                    }
                  }
                }

                this.buildCertificationList();
              } else {
                this.errorMsg = false;
              }
            });
          } else {
            this.errorMsg = false;
          }
        });
      }
    });
    this.onCloseHandled("confirmationModal");
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/assign-test-administration/assign-test-administration.component.ts